import React from "react";

import { NumberFormatCustom } from "../../common/helpers";
import { getBenchmarkColumnName } from "../../helpers/nameHelpers";

import { TextField } from "@material-ui/core";

function getBenchmarkTotal(benchmark, isCAD) {
  return !benchmark
    ? 0
    : 0 +
        (benchmark.oneMonthTbill ? parseFloat(benchmark.oneMonthTbill) : 0) +
        (benchmark.mainIndex ? parseFloat(benchmark.mainIndex) : 0) +
        (benchmark.secondaryIndex ? parseFloat(benchmark.secondaryIndex) : 0) +
        (benchmark.tenYearBond ? parseFloat(benchmark.tenYearBond) : 0) +
        (isCAD
          ? benchmark.worldDeveloped
            ? parseFloat(benchmark.worldDeveloped)
            : 0
          : 0) +
          (benchmark.goldETF ? parseFloat(benchmark.goldETF) : 0);
}

const Benchmarks = (props) => {
  const { actions, portfolio } = props;
  var benchmark = portfolio.benchmarks.find((e) => e.key === "clientSpecified");

  if (!benchmark) {
    benchmark = { key: "clientSpecified" };
  }

  const contentCellWidth = 150;
  const leftCellWidth = 150;

  const border = "1px solid #cac9c9";

  const isCAD = portfolio.currencyType === "CAD";
  const sum = getBenchmarkTotal(benchmark, isCAD);

  function getTextCell(benchmark, name, hasBorder) {
    return (
      <div
        style={{
          width: contentCellWidth,
          minWidth: contentCellWidth,
          textAlign: "center",
          padding: 5,
          borderLeft: hasBorder ? border : "",
        }}
      >
        <TextField
          value={benchmark[name] ? benchmark[name] * 100 : ""}
          variant="outlined"
          type="percent"
          InputProps={{
            inputComponent: NumberFormatCustom,
            inputProps: {
              style: {
                padding: 10,
              },
            },
          }}
          onChange={(event) => {
            actions.setBenchmarkValue(
              props,
              portfolio.portfolioNumber,
              name,
              event.target.value,
              benchmark.key,
            );
          }}
        />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", fontSize: 14 }}>
      <div style={{ display: "flex" }}>
        <div
          style={{ width: leftCellWidth, minWidth: leftCellWidth, padding: 5 }}
        ></div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
            borderLeft: border,
          }}
        >
          {getBenchmarkColumnName("mainIndex", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("secondaryIndex", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("tenYearBond", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("oneMonthTbill", portfolio.currencyType)}
        </div>
        {isCAD && (
          <div
            style={{
              width: contentCellWidth,
              minWidth: contentCellWidth,
              padding: 5,
              textAlign: "center",
            }}
          >
            {getBenchmarkColumnName("worldDeveloped", portfolio.currencyType)}
          </div>
        )}
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("goldETF", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
            borderLeft: border,
          }}
        >
          Allocation Sum
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: leftCellWidth,
            minWidth: contentCellWidth,
            paddingTop: 15,
            paddingLeft: 5,
            paddingRight: 5,
            textAlign: "right",
          }}
        >
          <span style={{ paddingRight: 10 }}>Your Benchmark</span>
        </div>
        {getTextCell(benchmark, "mainIndex", true)}
        {getTextCell(benchmark, "secondaryIndex", false)}
        {getTextCell(benchmark, "tenYearBond", false)}
        {getTextCell(benchmark, "oneMonthTbill", false)}
        {isCAD && getTextCell(benchmark, "worldDeveloped", false)}
        {getTextCell(benchmark, "goldETF", false)}
        <div
          style={{
            width: leftCellWidth,
            minWidth: leftCellWidth,
            paddingTop: 15,
            paddingLeft: 5,
            paddingRight: 5,
            borderLeft: border,
            whiteSpace: "nowrap",
          }}
        >
          <span
            style={{
              color: (sum * 100).toFixed(0) !== "100" ? "red" : "initial",
            }}
          >
            {(sum * 100).toFixed(0) + " %"}
          </span>
        </div>
      </div>
    </div>
  );
};

const Render = Benchmarks;

const getErrors = (props) => {
  const ret = [];

  const { portfolio } = props;

  var benchmark = portfolio.benchmarks.find((e) => e.key === "clientSpecified");

  const isCAD = portfolio.currencyType === "CAD";
  const benchmarkSum = getBenchmarkTotal(benchmark, isCAD);

  if ((benchmarkSum * 100).toFixed(0) !== "100") {
    ret.push("Allocations must add to 100%");
  }

  return ret;
};

function isComplete(props) {
  const errors = getErrors(props);

  return errors.length === 0;
}

const Title = "Benchmark Data";
const Description = () => (
  <div>
    <p>
      Specify the Portfolio Benchmark that best describes your starting or
      desired asset allocations for your portfolio.
    </p>
  </div>
);

const Preview = (props) => {
  if (!isComplete(props)) {
    return <div>Not Entered</div>;
  }

  const { portfolio } = props;

  const isCAD = portfolio.currencyType === "CAD";

  var benchmark = portfolio.benchmarks.find((e) => e.key === "clientSpecified");

  if (!benchmark) {
    benchmark = { key: "clientSpecified", selected: true };
  }

  const contentCellWidth = 150;

  const border = "1px solid #cac9c9";

  function getTextCell(benchmark, name, hasBorder) {
    return (
      <div
        style={{
          width: contentCellWidth,
          minWidth: contentCellWidth,
          textAlign: "center",
          marginTop: 15,
          padding: 5,
          borderLeft: hasBorder ? border : "",
        }}
      >
        {benchmark[name] ? `${benchmark[name] * 100}%` : "0%"}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", fontSize: 14 }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: 250, padding: 5 }}></div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
            borderLeft: border,
          }}
        >
          {getBenchmarkColumnName("mainIndex", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("secondaryIndex", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("tenYearBond", portfolio.currencyType)}
        </div>
        <div
          style={{
            width: contentCellWidth,
            minWidth: contentCellWidth,
            padding: 5,
            textAlign: "center",
          }}
        >
          {getBenchmarkColumnName("oneMonthTbill", portfolio.currencyType)}
        </div>
        {isCAD &&
          getBenchmarkColumnName("worldDeveloped", portfolio.currencyType)}
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: 250,
            paddingTop: 15,
            paddingLeft: 5,
            paddingRight: 5,
            textAlign: "right",
          }}
        >
          <span style={{ paddingRight: 10 }}>Your Benchmark</span>
        </div>
        {getTextCell(benchmark, "mainIndex", true)}
        {getTextCell(benchmark, "secondaryIndex", false)}
        {getTextCell(benchmark, "tenYearBond", false)}
        {getTextCell(benchmark, "oneMonthTbill", false)}
        {isCAD && getTextCell(benchmark, "worldDeveloped", false)}
      </div>
    </div>
  );
};

export { isComplete, Render, Description, Preview, Title, getErrors };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/Benchmarks.js